import { FC } from "react";

interface AdaLogoProps {
  className?: string;
}

export const AdaLogo: FC<AdaLogoProps> = ({ className = "w-5 h-5" }) => (
  <img
    src="https://app.sundae.fi/images/cardano.png"
    alt="ADA"
    className={`rounded-full ${className}`}
  />
);
